import { useUser } from 'contexts/UserContext'
import PropTypes from 'prop-types'
import { useState } from 'react'
import { AiFillCaretDown, AiFillCaretUp } from 'react-icons/ai'
import { Link } from 'wouter'
import SubMenuItems from './SubMenuItems'

export default function MenuItems({
  item,
  location,
  isSidebarOpen,
  setIsSidebarOpen
}) {
  const { user } = useUser()

  // Estado para controlar el despliegue del submenú de cada ítem
  const [dropdown, setDropdown] = useState(false)

  // Estado para abrir automáticamente el submenú si coincide con la URL al cargar la página
  const [firstTimeAutoOpen, setFirstTimeAutoOpen] = useState(true)

  return (
    <>
      {/* Entramos si el menú es desplegable, si tiene submenú */}
      {item?.subMenuItems ? (
        <>
          {/* 
            Explicación de las validaciones en 'className':
              - Se resalta el ítem principal si el usuario está en un ítem de submenú (ej. 'Plátano' dentro de 'Frutas').
              - Al abrir un submenú, se resalta el ítem principal para indicar que tiene submenú. 
              - Si la URL contiene el slug padre del submenú, se resalta el ítem principal desde donde se accedió (esto es útil cuando accedemos a un ítem de una lista y nos lleva a un formulario, permitiendo resaltar la página de origen).
              - Si el ítem está activo y no se cumplen las condiciones anteriores, se le agrega una animación de hover.
          */}
          <li className="flex" title={item?.title} key={item?.title}>
            <Link
              id={item?.title}
              href={item?.slug}
              onClick={() => {
                setDropdown((state) => !state)
              }}
              className={`inline-flex items-center pr-3 pl-4 py-1.5 text-base text-white duration-300 grow border-s-2 whitespace-nowrap text-ellipsis ${
                item?.subMenuItems.some(
                  (submenu) =>
                    submenu.slug === location ||
                    location.startsWith(submenu.parentSlug)
                ) || dropdown
                  ? '*:text-accent border-accent'
                  : item?.active &&
                    'border-white text-white hover:border-accent hover:text-accent'
              }`}
            >
              <div
                className={`${isSidebarOpen ? 'w-1/6 my-auto' : 'flex items-center flex-row justify-between w-6/6'}`}
              >
                {item?.icon}
                {item?.subMenuItems &&
                  !isSidebarOpen &&
                  (dropdown ? <AiFillCaretUp /> : <AiFillCaretDown />)}
              </div>

              <div
                className={`w-5/6 ml-0 md:ml-3 flex items-center justify-between uppercase origin-left duration-75 ${!isSidebarOpen && 'scale-0'}`}
              >
                <span>{item?.title}</span>

                {item?.subMenuItems &&
                  (dropdown ? (
                    <AiFillCaretUp title="Ocultar submenú" />
                  ) : (
                    <AiFillCaretDown title="Mostrar submenú" />
                  ))}
              </div>
            </Link>
          </li>

          <ul
            className={`space-y-2 font-medium list-none ${!dropdown && 'hidden'}`}
          >
            {item?.subMenuItems
              .filter((item) => item.roles?.includes(user.role_id))
              .map((submenu, index) => {
                // Abrir el submenú automáticamente si la URL coincide con el submenú
                if (
                  (location === submenu.slug ||
                    location.startsWith(submenu.parentSlug)) &&
                  firstTimeAutoOpen
                ) {
                  setDropdown(true)
                  setFirstTimeAutoOpen(false)
                }

                return (
                  <SubMenuItems
                    key={submenu.slug}
                    submenu={submenu}
                    location={location}
                    isSidebarOpen={isSidebarOpen}
                    setIsSidebarOpen={setIsSidebarOpen}
                  />
                )
              })}
          </ul>
        </>
      ) : (
        <>
          <li className="flex" title={item?.title} key={item?.title}>
            {/* 
              Explicación de las validaciones en 'className':
                - Se resalta el ítem principal si el usuario está dentro.
                - Si la URL contiene el slug padre del submenú, se resalta el ítem principal desde donde se accedió (esto es útil cuando accedemos a un ítem de una lista y nos lleva a un formulario, permitiendo resaltar la página de origen).
                - Si el ítem está activo y no se cumplen las condiciones anteriores, se le agrega una animación de hover.
            */}
            <Link
              id={item?.title}
              href={item?.slug}
              className={`inline-flex items-center pr-3 pl-4 py-1.5 text-base text-white duration-300 grow border-s-2 whitespace-nowrap text-ellipsis ${
                item?.slug === location || location.startsWith(item?.parentSlug)
                  ? '*:text-accent border-accent'
                  : item?.active &&
                    'border-white text-white hover:border-accent hover:text-accent'
              }`}
              onClick={() => {
                if (setIsSidebarOpen) {
                  setIsSidebarOpen(false)
                }
              }}
            >
              <span className={`w-1/6 my-auto`}>{item?.icon}</span>

              <span
                className={`w-5/6 ml-0 md:ml-3 origin-left duration-75 uppercase ${!isSidebarOpen && 'scale-0'}`}
              >
                {item?.title}
              </span>
            </Link>
          </li>
        </>
      )}
    </>
  )
}

MenuItems.propTypes = {
  item: PropTypes.object,
  user: PropTypes.object,
  location: PropTypes.string,
  isSidebarOpen: PropTypes.any,
  setIsSidebarOpen: PropTypes.any
}
